import { z } from 'my-zod'

export const PlanNameEnum = z
  .enum(['Base', 'Plus', 'Ultimate', 'Beta', 'Test', 'EmployeeADV', 'Unlimited', 'UnlimitedPlus', 'ArizonaSeasonPass'])
  .setEnumLabels({
    Base: 'Base',
    Plus: 'Plus',
    Ultimate: 'Ultimate',
    Beta: 'Beta',
    Test: 'Test',
    EmployeeADV: 'EmployeeADV',
    Unlimited: 'Unlimited',
    UnlimitedPlus: 'Unlimited Plus',
    ArizonaSeasonPass: 'Arizona Season Pass'
  })

export const PlanNames = PlanNameEnum.Values
export type PlanName = z.infer<typeof PlanNameEnum>
export const PlanNameOptions = Object.values(PlanNames)
export const PlanNameLabels = PlanNameEnum.enumLabels

export function isLimitedCreditPlan(plan: { name: string } | null) {
  return [
    PlanNames.Base,
    PlanNames.Plus,
    PlanNames.Ultimate,
    PlanNames.EmployeeADV,
    PlanNames.Test,
    PlanNames.ArizonaSeasonPass
  ].find((p) => plan?.name === p)
}
